// Import
import { Typography, useTheme, TextField } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import {
  InputCst,
  SelectCst,
  AutocompleteCst,
  MultiSelectCst,
  RadioCst,
  DataPickerCst,
  SingleCheckboxCst,
  InputAssociationChipsCst,
  MultiTextCst,
  EuroTextCst,
} from "@components/InputCst";
import { AssociationModalContainer } from "@components/StakeholdersCst/style";
import { ColumnInterface } from "@components/Table/types";
import { Box, Grid, Modal } from "@mui/material";
import { useTranslation } from "react-i18next";
import BackgroundImageCst from "@components/BackgroundImageCst";
import { defaultValidation } from "@utils/utilsValidators";
import ButtonCst from "@components/ButtonCst";
import DownloaderUploaderCst from "@components/DownloaderUploaderCst";
import { useNavigate } from "react-router-dom";
import InputChipsCst from "@components/InputCst/InpuctChipsCst";
import AssociationLibraryCst from "@components/AssociationLibraryCst";
import AssociationTableCst from "@components/AssociationTableCst";
import { PagesID } from "@utils/utilsConfigurations";
import TimePickerCst from "@components/InputCst/TimePickerCst";
import { TextEditorCst } from "@components/TextEditorCst";
import { Association } from "src/interfaces/Common";
import InputAdornment from "@mui/material/InputAdornment";
import EuroIcon from "@mui/icons-material/Euro";
import Switch from "@mui/material/Switch";
import { isTrueValue } from "@utils/utilsValidators";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { UseLabelTableStyles } from "@hooks/useLabelTableStyles";
import internal from "stream";

interface CostProjectFormCstInterface {
  row?: any;
  columns: ColumnInterface[];
  additionalColumns?: ColumnInterface[];
  actionsForForms?: ColumnInterface[];
  onSubmit: (inputForm: any, sendToApproval: boolean) => void;
  onReset?: () => void;
  formActionType?: string[];
  dragDrop?: boolean;
  inputsException?: (col: any, inputForm: any) => any;
  backButton?: () => any;
  getValues?: (accessorKey: string) => any;
  handleDelete?: (accessorKey: string, element: any) => void;
  handleAssociation?: (accessorKey: string, value: any) => void;
  setOpenAssociation?: (
    accessorKey: string,
    open: boolean,
    inputForm: any,
  ) => void;
  resetCostProjectAssociations?: () => void;
  association?: boolean | Association;
  isFaculties?: boolean;
  disabledConfig?: { view: string; accessoryKey: string };
  readOnly?: boolean;
  isCorporate?: boolean;
  deleteDisabled?: boolean;
  options?: any;
  LoCounter?: boolean;
  LoCountValue?: number;
  LoCountMaxSelection?: number;
  optionsSelect?: any;
  getOptionValue?: any;
  durationKey?: boolean; // valore da settare se vogliamo dare al form anche la DURATA dell'elemento selezionato nella grid
  fullWidth?: boolean;
  categoryAssociation?: any;
  supplierAssociation?: any;
  dataProject?: any;
  setSupplierAssociation?: any;
  setCategoryAssociation?: any;
  setContractAssociation?: any;
  isEdit?: boolean;
  isManage?: boolean;
}

// eslint-disable-next-line no-empty-pattern
const CostProjectFormCst: React.FC<CostProjectFormCstInterface> = ({
  row,
  columns,
  actionsForForms = [],
  dragDrop,
  inputsException,
  onSubmit,
  onReset,
  backButton,
  getValues,
  handleDelete,
  handleAssociation,
  setOpenAssociation,
  resetCostProjectAssociations,
  setSupplierAssociation,
  setCategoryAssociation,
  setContractAssociation,
  association,
  readOnly,
  LoCounter,
  LoCountValue,
  LoCountMaxSelection,
  optionsSelect,
  durationKey,
  fullWidth = false,
  categoryAssociation,
  supplierAssociation,
  dataProject,
  isEdit = false,
  isManage = false,
}) => {
  const theme = useTheme();
  const { t } = useTranslation(["form"]);
  const navigate = useNavigate();
  const [inputForm, setInputForm] = React.useState<any>({});
  const [errorInputForm, setErrorInputForm] = React.useState<any>({});
  const [fileUploaded, setFileUploaded] = React.useState<any>(null);
  const [isBlocked, setIsBlocked] = useState(false);
  const [openUserAssociation, setOpenUserAssociation] = useState(false);

  const getInitialData = () => {
    let initialState: Record<string, any> = {};
    columns?.forEach(({ accessorKey }) => {
      switch (accessorKey) {
        case "budget_project_categorization":
          if (
            row.budget_project_categorization != null &&
            row.budget_project_categorization.macro_category != null
          ) {
            row.budget_project_categorization.label =
              row.budget_project_categorization.macro_category.title;
            setCategoryAssociation &&
              setCategoryAssociation([row.budget_project_categorization]);
          }

          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
        case "supplier":
          if (row.contract != null && row.contract.supplier != null) {
            row.supplier = {
              label: row.contract.supplier.business_name,
              id: row.contract.supplier.id,
            };
            setSupplierAssociation && setSupplierAssociation([row.supplier]);
          }

          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
        case "contract":
          if (row.contract != null) {
            row.contract.label = row.contract.sap_code;
            setContractAssociation && setContractAssociation([row.contract]);
          }

          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
        case "available_budget":
          if (row.budget_project_categorization != null) {
            row.available_budget =
              row.budget_project_categorization.available_budget +
              (isEdit ? row.total_cost : 0);
          }

          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
        case "management_type":
          if (row.management_type == null) {
            row.management_type = "TBD";
          }

          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
        case "request_type":
          if (row.management_type && row.management_type !== "TBD") {
            row.request_type = row.management_type;
          }

          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
        default:
          initialState = {
            ...initialState,
            [accessorKey]: row[accessorKey],
          };
          break;
      }
    });

    return initialState;
  };

  useEffect(() => {
    if (!isEdit) {
      setInputForm((prevInputForm: any) => ({
        ...prevInputForm,
        funded: !!dataProject.funded,
        internal: false,
      }));
    }
  }, [dataProject]);

  const resetInputForm = () => {
    let initialState = {};
    onReset && onReset();
    if (row) {
      resetCostProjectAssociations && resetCostProjectAssociations();
      setInputForm(getInitialData());
    } else {
      setInputForm(initialState);
    }
    setIsBlocked(false);
  };

  useEffect(() => {
    if (row && Object.keys(row).length > 0 && columns?.length > 0) {
      const initialState = getInitialData();
      setInputForm(initialState);

      // Disable all columns if readOnly=true prop is passed
      if (readOnly) {
        columns?.forEach((column) => (column.disabled = true));
      }
    }
  }, [row, columns]);

  //TODO: refactor validation v.1
  const onConfirm = (sendToApproval: boolean = false) => {
    // FIXME: defaultValidation non effettua validazione de i campi upload (es. upload image certificati anche se required non viene validato).
    // fix predisposta in branch fix/actionsForFormsValidation
    const { canBeSubmit, showError } = defaultValidation(columns, inputForm);

    if (
      inputForm.total_cost &&
      inputForm.available_budget &&
      inputForm.total_cost > inputForm.available_budget
    ) {
      setErrorInputForm({
        ...showError,
        total_cost: {
          msg: "invalid-total-cost",
        },
      });
      return;
    }

    if (
      !isManage &&
      (inputForm.available_budget == null ||
        isNaN(Number(inputForm.available_budget)) ||
        Number(inputForm.available_budget) === 0)
    ) {
      setErrorInputForm({
        ...showError,
        available_budget: {
          msg: "invalid-available-budget",
        },
      });
      return;
    }

    setErrorInputForm(showError);

    // in base alla presenza del error nel col:descrizione errore,  vado a settare un messaggio di errore nel file config delle traduzioni
    // ES. viene utilizzata per le associazioni sezione Gestione Finanziata
    let stringError = "";
    const findErrorCol = columns.map((el) => {
      if (el.error) {
        stringError = el.error;
        return {
          [el.accessorKey]: {
            msg: el.error,
          },
        };
      } else {
        return;
      }
    });
    //logica errore sul col.error settata nella callback inputsException vedi Gestione Finanziata associazioni o sezione PIANI data inizio e data fine
    const mergeErrorArray = Object.assign({}, ...findErrorCol);
    if (Object.keys(mergeErrorArray).length > 0) {
      setErrorInputForm({ ...showError, ...mergeErrorArray });
    }
    //logica errore sul col.error settata nella callback inputsException END

    if (canBeSubmit) {
      setIsBlocked(false);
      onSubmit(inputForm, sendToApproval);
    }
  };

  const getErrMsg = (accessorKey: string): string => {
    return errorInputForm[accessorKey]?.msg || errorInputForm[accessorKey];
  };

  const minLength = (accessorKey: string): number => {
    return errorInputForm[accessorKey]?.value;
  };

  const maxLength = (accessorKey: string): number => {
    return errorInputForm[accessorKey]?.value;
  };

  useEffect(() => {
    if (!isEdit && !isManage) {
      let isBudget =
        isNaN(Number(categoryAssociation?.[0]?.available_budget)) ||
        Number(categoryAssociation?.[0]?.available_budget) <= 0
          ? 0
          : Number(categoryAssociation?.[0]?.available_budget);
      setInputForm((prev: any) => ({
        ...prev,
        available_budget:
          Number(categoryAssociation?.[0]?.available_budget) || null,
        unit_cost: isBudget
          ? Number(categoryAssociation?.[0]?.available_budget)
          : null,
        qt: isBudget ? 1 : null,
        total_cost: categoryAssociation?.length ? prev.total_cost : null,
      }));
    }
  }, [categoryAssociation]);

  useEffect(() => {
    setInputForm((prev: any) => ({
      ...prev,
      total_cost: prev.unit_cost && prev.qt ? prev.unit_cost * prev.qt : null,
    }));
  }, [inputForm]);

  const getInputsList = (col: any, detailForm: any, dataProject: any) => {
    if (inputsException) {
      col = inputsException(col, detailForm);
    }

    if (col.visibilityInForm == false) return;

    switch (col.accessorKey) {
      case "budget_project_categorization":
        col.disabled = detailForm.internal == null || isEdit;
        break;

      case "qt":
      case "unit_cost":
        col.disabled =
          !(categoryAssociation && categoryAssociation.length > 0) ||
          isNaN(Number(detailForm.available_budget));
        break;

      case "contract":
        col.disabled =
          !(supplierAssociation && supplierAssociation.length > 0) ||
          isTrueValue(detailForm.internal);
        col.required = !isTrueValue(detailForm.internal);
        break;

      case "supplier":
        col.disabled = isTrueValue(detailForm.internal);
        col.required = !isTrueValue(detailForm.internal);
        break;

      case "person_days":
        col.disabled = !isTrueValue(detailForm.internal);
        col.required = isTrueValue(detailForm.internal);
        break;

      case "internal":
        col.callBack = (e: any, row: any) => {
          setCategoryAssociation([]);
          setSupplierAssociation([]);
          setContractAssociation([]);
          return {
            ...inputForm,
            internal: e,
            qt: undefined,
            unit_cost: undefined,
            total_cost: undefined,
          };
        };
    }

    switch (col.type) {
      case "association": {
        return (
          <Grid
            key={col.accessorKey}
            item
            xs={12}
            sm={col.fullWidth ? 12 : col.half ? 6 : 4}
          >
            <InputAssociationChipsCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              value={getValues && getValues(col.accessorKey)}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              noAssociationButton={col.disableAssociationButton}
              disabled={col.disabled}
              textTooltip={col.tooltip}
              required={col.required}
              onDelete={(e: any) => {
                setIsBlocked(true);
                handleDelete && handleDelete(col.accessorKey, e);
              }}
              onRedirect={() => {
                setIsBlocked(true);
                setOpenUserAssociation(true);
                setOpenAssociation &&
                  setOpenAssociation(col.accessorKey, true, inputForm);
              }}
              labelKey={col.labelKey}
            />
          </Grid>
        );
      }
      case "singleCheckbox": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <SingleCheckboxCst
              key={col.accessorKey}
              id={col.accessorKey}
              value={inputForm[col.accessorKey]}
              label={col.header}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({
                  ...inputForm,
                  ...{ [col.accessorKey]: e.target.checked },
                });
              }}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
            />
          </Grid>
        );
      }
      case "text": {
        return (
          <Grid
            key={col.accessorKey}
            item
            xs={12}
            sm={col.fullWidth ? 12 : col.half ? 6 : 4}
          >
            <InputCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              value={inputForm[col.accessorKey]}
              required={col.required}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({
                  ...inputForm,
                  ...{ [col.accessorKey]: e.target.value },
                });
              }}
              maxValue={col?.rules?.max?.value}
              multiline={col.multiline}
              rows={col.rows}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
              textTooltip={col.tooltip}
              type={col.inpuType || "text"}
            />
          </Grid>
        );
      }
      case "chips": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <InputChipsCst
              label={col.header}
              id={col.accessorKey}
              value={inputForm[col.accessorKey]}
              required={col.required}
              maxLength={col?.rules?.max?.value}
              disabled={col.disabled}
              textTooltip={col.textTooltip}
              validationType={col.validationType}
              error={errorInputForm[col.accessorKey] ? true : false}
              onAdd={(list: any[]) => {
                setIsBlocked(true);
                setInputForm({
                  ...inputForm,
                  ...{ [col.accessorKey]: list },
                });
              }}
              deleteDisabled={col.deleteDisabled}
              undeletableValues={col.undeletableValues}
            />
          </Grid>
        );
      }
      case "dynamicSelect": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <SelectCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              optionsToDisable={col.optionsToDisable}
              value={inputForm[col.accessorKey]?.value || ""}
              service={col.service}
              required={col.required}
              onChange={(selected: any) => {
                setIsBlocked(true);
                if (col.callBack) {
                  setInputForm(col.callBack(selected, row));
                } else {
                  setInputForm({
                    ...inputForm,
                    ...{
                      [col.accessorKey]: optionsSelect.find(
                        (el: any) => el.value === selected,
                      ),
                    },
                  });
                }
              }}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              options={optionsSelect}
              textTooltip={col.tooltip}
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "dynamicUOGSelect": {
        let error = false;
        const buildLevels = (data: any) => {
          const levels: any = {};

          const rootItem = data.find((el: any) => el.parent_code == "NULL");

          function getLevelItems(parentCode: string, level: number) {
            if (!levels[level]) levels[level] = [];
            const items = data.filter(
              (item: any) => item.parent_code === parentCode,
            );

            if (items.length === 0) return;

            levels[level].push(...items);

            items.forEach((item: any) => getLevelItems(item.code, level + 1));
          }

          if (rootItem) {
            error = false;
            getLevelItems(rootItem.code, 1);
          } else {
            error = true;
          }

          const fullLevels = {
            "0": [rootItem],
            ...levels,
          };

          const options = Object.keys(fullLevels)
            .filter((levelIndex) => fullLevels[levelIndex].length > 0)
            .map((levelIndex) => ({
              name: `${levelIndex}`,
              value: levelIndex,
              label: `${levelIndex}`,
            }));

          return options;
        };

        const optionChoice = buildLevels(optionsSelect);

        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <SelectCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              optionsToDisable={col.optionsToDisable}
              value={inputForm[col.accessorKey]}
              service={col.service}
              required={col.required}
              onChange={(selected: any) => {
                setIsBlocked(true);
                if (col.callBack) {
                  setInputForm(col.callBack(selected, row));
                } else {
                  setInputForm({
                    ...inputForm,
                    ...{ [col.accessorKey]: selected },
                  });
                }
              }}
              options={optionChoice}
              textTooltip={col.tooltip}
              error={!!errorInputForm[col.accessorKey] || !!error}
              errorMessage={
                error
                  ? t("error.field.uog-hierarchy") || ""
                  : t("error.field.required") || ""
              }
              disabled={error || col.disabled}
            />
          </Grid>
        );
      }
      case "select": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <SelectCst
              key={col.accessorKey}
              id={col.accessorKey}
              optionsKey={col.optionsKey}
              label={col.header}
              optionsToDisable={col.optionsToDisable}
              value={inputForm[col.accessorKey]} //REFACTOR temp to show right value on select
              service={col.service}
              required={col.required}
              onChange={(e: any) => {
                setIsBlocked(true);
                if (col.callBack) {
                  setInputForm(col.callBack(e, row));
                } else {
                  setInputForm({ ...inputForm, ...{ [col.accessorKey]: e } });
                }
              }}
              options={col?.options}
              textTooltip={col.tooltip}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "select-checkbox": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <MultiSelectCst
              id={col.accessorKey}
              label={col.header}
              optionsKey={col.optionsKey}
              value={inputForm[col.accessorKey]}
              optionsToDisable={col.optionsToDisable}
              disabled={col.disabled}
              onChange={(e: any) => {
                setIsBlocked(true);
                let newValue = JSON.parse(JSON.stringify(e));
                let newInputForm = JSON.parse(JSON.stringify(inputForm));
                setInputForm({
                  ...newInputForm,
                  ...{ [col.accessorKey]: newValue },
                });
              }}
              options={col.options}
              required={col.required}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
            />
          </Grid>
        );
      }
      case "autocomplete": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <AutocompleteCst
              key={col.accessorKey}
              id={col.accessorKey}
              optionsKey={col.optionsKey}
              label={col.header}
              value={inputForm[col.accessorKey]}
              required={col.required}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({ ...inputForm, ...{ [col.accessorKey]: e } });
              }}
              options={col?.options}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "multiCheckbox": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <MultiSelectCst
              key={col.accessorKey}
              id={col.accessorKey}
              optionsKey={col.optionsKey}
              label={col.header}
              value={inputForm[col.accessorKey]}
              textTooltip={col.tooltip}
              required={col.required}
              service={col.service}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({ ...inputForm, ...{ [col.accessorKey]: e } });
              }}
              options={col?.options}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "radio": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <RadioCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              value={inputForm[col.accessorKey]}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({ ...inputForm, ...{ [col.accessorKey]: e } });
              }}
              options={col.options}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "dateTime": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <DataPickerCst
              id={col.accessorKey}
              label={col.header}
              value={inputForm[col.accessorKey]}
              required={col.required}
              minDate={col.minDate}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({ ...inputForm, ...{ [col.accessorKey]: e } });
              }}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "dateTimeYear": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <DataPickerCst
              views={["year"]}
              id={col.accessorKey}
              label={col.header}
              value={inputForm[col.accessorKey]}
              required={col.required}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({ ...inputForm, ...{ [col.accessorKey]: e } });
              }}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
            />
          </Grid>
        );
      }
      case "time": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <TimePickerCst
              id={col.accessorKey}
              value={inputForm[col.accessorKey]}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`) || "Error"
              }
              required={col.required}
              label={col.header}
              disabled={col.disabled}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({ ...inputForm, ...{ [col.accessorKey]: e } });
              }}
            />
          </Grid>
        );
      }
      case "multi-text": {
        return (
          <MultiTextCst
            key={col.accessorKey}
            label={col.header}
            fields={col.fields}
            value={inputForm[col.accessorKey]}
            disabled={col.disabled}
            onChange={(e: any) => {
              setIsBlocked(true);
              setInputForm({
                ...inputForm,
                ...{ [col.accessorKey]: e },
              });
            }}
          />
        );
      }
      case "editor": {
        return (
          <TextEditorCst
            options={col.editorOptions}
            value={inputForm[col.accessorKey]}
            onChange={(e: any) => {
              setIsBlocked(true);
              setInputForm((prev: any) => {
                return {
                  ...prev,
                  [col.accessorKey]: e,
                };
              });
            }}
          />
        );
      }
      case "upload": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <DownloaderUploaderCst
              name={col.header}
              accept={col?.accept}
              url={col.service}
              type={col.upload_type}
              onChange={(e: any) => {
                setInputForm({
                  ...inputForm,
                  [col.accessorKey]: {
                    e,
                  },
                });
                setFileUploaded({
                  ...fileUploaded,
                  [col.accessorKey]: {
                    file: e,
                  },
                });
              }}
              fileName={!!row?.originalFileName && row.originalFileName}
              downloadDisabled={!!col.downloadDisabled}
              onDownload={col.downloadCallback && col.downloadCallback}
              onTemplateDownload={col.templateCallback && col.templateCallback}
              onDelete={
                col.deleteCallback &&
                (() => {
                  setFileUploaded(null);
                  return col.deleteCallback && col.deleteCallback();
                })
              }
              disabled={col.disabled}
              required={col?.required}
              showError={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
            />
          </Grid>
        );
      }
      case "textfield": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <TextField
              type="text"
              size="small"
              sx={{ width: "100%" }}
              error={errorInputForm[col.accessorKey] ? true : false}
              helperText={
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    margin: 0,
                  }}
                >
                  {errorInputForm[col.accessorKey]
                    ? t(`error.field.${getErrMsg(col.accessorKey)}`) || "Error"
                    : ""}
                </span>
              }
              value={new Intl.NumberFormat("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(inputForm[col.accessorKey] || 0))}
              inputProps={{
                sx: {
                  textAlign: "right",
                },
              }}
              InputProps={{
                readOnly: true,
                endAdornment: col.iconEnd ? (
                  <InputAdornment position="end">
                    {col.iconEnd === "euro" ? <EuroIcon /> : null}
                  </InputAdornment>
                ) : null,
                startAdornment: (
                  <InputAdornment position="end">
                    <p>{col.header}:</p>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        );
      }
      case "switch": {
        return (
          <Grid key={col.accessorKey} item xs={12} sm={col.half ? 6 : 4}>
            <TextField
              size="small"
              sx={{ width: "100%" }}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="end">
                    <p>{col.header}</p>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <Switch
                      disabled={col.disabled}
                      checked={
                        inputForm[col.accessorKey] !== undefined
                          ? inputForm[col.accessorKey]
                          : false
                      } // Imposta false di default se undefined
                      onChange={(e) => {
                        setInputForm({
                          ...inputForm,
                          [col.accessorKey]: e.target.checked,
                        });
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        );
      }
      case "euro-text": {
        return (
          <Grid
            key={col.accessorKey}
            item
            xs={12}
            sm={col.fullWidth ? 12 : col.half ? 6 : 4}
          >
            <EuroTextCst
              key={col.accessorKey}
              id={col.accessorKey}
              label={col.header}
              value={inputForm[col.accessorKey]}
              required={col.required}
              onChange={(e: any) => {
                setIsBlocked(true);
                setInputForm({
                  ...inputForm,
                  ...{ [col.accessorKey]: e.target.value },
                });
              }}
              maxValue={col?.rules?.max?.value}
              multiline={col.multiline}
              rows={col.rows}
              error={errorInputForm[col.accessorKey] ? true : false}
              errorMessage={
                t(`error.field.${getErrMsg(col.accessorKey)}`, {
                  min: minLength(col.accessorKey),
                  max: maxLength(col.accessorKey),
                }) || "Error"
              }
              disabled={col.disabled}
              textTooltip={col.tooltip}
              type={col.inpuType || "text"}
            />
          </Grid>
        );
      }
      default:
        return <></>;
    }
  };

  const getInputField = useMemo(() => {
    return columns?.map((col: any) => {
      return getInputsList(col, inputForm, dataProject);
    });
  }, [
    columns,
    inputForm,
    errorInputForm,
    t,
    getErrMsg,
    getValues,
    handleDelete,
    maxLength,
    minLength,
    setOpenAssociation,
  ]);

  return (
    <>
      {/* <BackButtonWarning isBlocked={isBlocked} /> */}
      {!association && (
        <Grid container>
          <Grid item xs={0} lg={fullWidth ? 0 : 4} xl={fullWidth ? 0 : 3}>
            <BackgroundImageCst
              image="section-internal-form.jpg"
              disableGradient
            />
          </Grid>
          <Grid item xs={12} lg={fullWidth ? 12 : 8} xl={fullWidth ? 12 : 9}>
            <Box
              sx={{
                backgroundColor: theme.palette.background.paper,
                padding: "22px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {isManage && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    flexDirection: { xs: "column", sm: "row" },
                    [theme.breakpoints.down("sm")]: {
                      flexDirection: "column",
                      gap: "20px",
                    },
                  }}
                >
                  <FiberManualRecordIcon
                    sx={{
                      color: UseLabelTableStyles(
                        "status_project_cost",
                        row?.status || "",
                      ),
                      mr: { xs: 0, sm: 1 },
                      mb: { xs: 1, sm: 0 },
                    }}
                  />
                  <Typography variant="body1" sx={{ mr: 1 }}>
                    {dataProject?.title} -{" "}
                    <strong>
                      {new Intl.NumberFormat("it-IT", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(Number(dataProject?.total_cost))}
                      €
                    </strong>
                  </Typography>
                </Box>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderBottom: "1px dashed #6d6d6d",
                  marginBottom: 20,
                }}
              />

              {isManage && !readOnly && (
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 4,
                      [theme.breakpoints.down("sm")]: {
                        flexDirection: "column",
                        gap: "20px",
                      },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="h6" sx={{ mr: 1 }}>
                        Step 1
                      </Typography>
                      <Typography variant="body1">
                        - {t("project-cost.label")}
                      </Typography>
                    </Box>
                    {dataProject?.status == "DRAFT" && (
                      <ButtonCst
                        id={"save-button"}
                        variant={"contained"}
                        size={"medium"}
                        sx={{
                          minWidth: "150px",
                          [theme.breakpoints.down("lg")]: {
                            minWidth: "100px",
                          },
                          [theme.breakpoints.down("sm")]: {
                            minWidth: "100%",
                          },
                        }}
                        onClick={() => onConfirm(true)}
                        disabled={!!readOnly}
                      >
                        {t("project-cost.send-to-approve")}
                      </ButtonCst>
                    )}
                  </Grid>
                </Grid>
              )}

              <Grid container spacing={3}>
                {getInputField}
              </Grid>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderBottom: "1px dashed #6d6d6d",
                  marginTop: 20,
                }}
              />

              <Grid container spacing={3}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    mt: "32px",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    justifyContent: "space-between",
                    [theme.breakpoints.down("sm")]: {
                      flexDirection: "column",
                    },
                  }}
                >
                  <ButtonCst
                    id={"back-button"}
                    variant={"outlined"}
                    size={"medium"}
                    sx={{
                      minWidth: "150px",
                      mr: "auto",
                      [theme.breakpoints.down("lg")]: {
                        minWidth: "100px",
                      },
                      [theme.breakpoints.down("sm")]: {
                        minWidth: "100%",
                      },
                    }}
                    onClick={() => {
                      if (backButton) {
                        backButton();
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    {t("backButton")}
                  </ButtonCst>
                  <ButtonCst
                    id={"reset-button"}
                    variant={"outlined"}
                    size={"medium"}
                    sx={{
                      minWidth: "150px",
                      [theme.breakpoints.down("lg")]: {
                        minWidth: "100px",
                      },
                      [theme.breakpoints.down("sm")]: {
                        minWidth: "100%",
                      },
                    }}
                    onClick={resetInputForm}
                  >
                    {t("resetButton")}
                  </ButtonCst>
                  <ButtonCst
                    id={"save-button"}
                    variant={"contained"}
                    size={"medium"}
                    sx={{
                      minWidth: "150px",
                      [theme.breakpoints.down("lg")]: {
                        minWidth: "100px",
                      },
                      [theme.breakpoints.down("sm")]: {
                        minWidth: "100%",
                      },
                    }}
                    onClick={() => onConfirm()}
                    disabled={!!readOnly}
                  >
                    {t("saveButton")}
                  </ButtonCst>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      )}
      {(association as { type: string })?.type === "library" && (
        <AssociationLibraryCst
          association={
            getValues && getValues((association as Association).accessorKey)
          }
          setAssociation={(value: any) => {
            handleAssociation &&
              handleAssociation(
                (association as Association).accessorKey,
                value,
              );
          }}
          setCloseAssociation={(value: boolean) =>
            setOpenAssociation &&
            setOpenAssociation(
              (association as Association).accessorKey,
              value,
              inputForm,
            )
          }
          filters={[
            {
              field: "type",
              value: (association as Association).mediaType,
            },
          ]}
          multiple
          title={t((association as Association).titleKey)}
        />
      )}
      {(association as { type: string })?.type === "table" && (
        <Modal
          open={openUserAssociation}
          onClose={() => setOpenUserAssociation(false)}
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          }}
        >
          <AssociationModalContainer theme={theme}>
            <AssociationTableCst
              association={
                getValues && getValues((association as Association).accessorKey)
              }
              setAssociation={(value: any) => {
                handleAssociation &&
                  handleAssociation(
                    (association as Association).accessorKey,
                    value,
                  );
                setInputForm({
                  ...inputForm,
                  ...{ [(association as Association).accessorKey]: value },
                });
              }}
              setCloseAssociation={(value: boolean) =>
                setOpenAssociation &&
                setOpenAssociation(
                  (association as Association).accessorKey,
                  value,
                  inputForm,
                )
              }
              title={t((association as Association).titleKey)}
              service={(association as { service: string }).service}
              pageID={(association as { pageId: PagesID }).pageId}
              filter={(association as Association).accessorKey}
              defaultFilters={(association as Association).defaultFilters}
              manageConfigs={(association as Association).manageConfigs}
              enableMultiRowSelection={(association as Association).multiChoice}
              labelKey={(association as Association).labelKey}
              durationKey={durationKey || false}
            />
          </AssociationModalContainer>
        </Modal>
      )}
    </>
  );
};

export default CostProjectFormCst;
